import type { UpgradeRow } from '../../api/inventoree'
import type { TableColumn } from '../../ui/DataTable'

/**
 * Coloanele din InventoreeAlarmsModel (public/js/inventoree.js),
 * celula cu celula.
 */

export interface UpgradeColumn extends TableColumn {
  name?: string
}

const MINUS = '<center><i class="fas fa-minus font-10"></i></center>'

export function flagHtml(flag: number | string): string {
  switch (String(flag)) {
    case '0':
      return '<center title="Info"><i class="fas font-16 color-blue fa-info"></i></center>'
    case '1':
      return '<center title="Minor"><i class="fas font-16 color-green2 fa-exclamation-triangle"></i></center>'
    case '2':
      return '<center title="Major"><i class="fas font-16 color-yellow fa-exclamation-triangle"></i></center>'
    case '3':
      return '<center title="Critical"><i class="fas font-16 color-red fa-exclamation-circle"></i></center>'
  }
  return MINUS
}

export function valuesHtml(r: UpgradeRow): string {
  if (String(r.dinamic) === '1') {
    return `${r.from_value} ${r.sign} - ${r.to_value} ${r.sign}`
  }
  if (String(r.dinamic) === '2') {
    return `${r.from_value}${r.sign}`
  }
  return ''
}

export function statusHtml(status: number | string): string {
  if (String(status) === '1') {
    return '<center><i class="fas font-16 color-green2 fa-check-square"></i></center>'
  }
  return '<center><i class="fas font-16 color-red fa-minus-square"></i></center>'
}

export function upgradeColumns(): UpgradeColumn[] {
  const cell = (fn: (r: UpgradeRow) => string) => (row: Record<string, unknown>) => fn(row as unknown as UpgradeRow)
  return [
    {
      index: 0,
      title: '',
      orderable: false,
      visible: true,
      width: 50,
      name: 'ID',
      html: cell((r) => `<center class="show_details color-dark-grey pointer font-16" data-id="${r.ID}"><i class="fas fa-plus-circle"></i></center>`),
    },
    { index: 1, title: 'Flag', orderable: true, visible: true, name: 'flag', html: cell((r) => flagHtml(r.flag)) },
    { index: 2, title: 'Upgrade Type', orderable: true, visible: true, name: 'type_name', html: cell((r) => String(r.type_name ?? '')) },
    { index: 3, title: 'Category', orderable: true, visible: true, name: 'category_name', html: cell((r) => String(r.category_name ?? '')) },
    { index: 4, title: 'Upgrade Values', orderable: true, visible: true, name: 'ID', html: cell((r) => valuesHtml(r)) },
    {
      index: 5,
      title: 'Upgrades',
      orderable: true,
      visible: true,
      name: 'affected_devices',
      html: cell((r) => `<center>${r.affected_devices}</center>`),
    },
    { index: 6, title: 'Status', orderable: true, visible: true, name: 'status', html: cell((r) => statusHtml(r.status)) },
  ]
}
